import { render, staticRenderFns } from "./guide-tabs.vue?vue&type=template&id=99403f62&"
import script from "./guide-tabs.vue?vue&type=script&lang=js&"
export * from "./guide-tabs.vue?vue&type=script&lang=js&"
import style0 from "./guide-tabs.vue?vue&type=style&index=0&id=99403f62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports